// extracted by mini-css-extract-plugin
export default {"root":"VerifyEmail_root__mzzd+"};